<template>
  <div class="customer__form modal modal--default">
    <div class="modal__panel modal__panel--termination">
      <div class="modal__logo-wrapper">
        <div class="modal__logo"></div>
      </div>

      <div class="modal__main-icon modal__main-icon--leads"></div>
      <div class="modal__close" @click="closeModal()"></div>

      <div class="form form--terminate">
        <div class="navigators">
          <div class="navigator navigator--active">
            <div class="navigator__bullet"></div>
            <div class="navigator__title">
              {{ isEditMode ? $t(`addLeadModal.${"editTitle"}`) : $t(`addLeadModal.${"title"}`) }}
            </div>
          </div>
        </div>
        <div class="add__form add__form--terminate">
          <transition name="fade" mode="out-in">
            <Loading v-if="formLoading" />
            <div v-else class="add__content">
              <div class="termination">
                <div class="termination__row">
                  <div class="termination__column">
                    <div class="form__field" v-if="customerDetails">
                      <div class="input input--default input--readonly">
                        <span v-if="customerDetails.member_type && customerDetails.member_type.id == 1">{{
                          customerDetails.company_name }}</span>
                        <span v-else>
                          {{ customerDetails.first_name }} {{ customerDetails.last_name }}</span>
                      </div>
                    </div>

                    <div class="form__field ">
                      <MultiSelectDropdown :items="categories" :reduce="(category) => category.id" label="name"
                        :placeholder="$t(`addLeadModal.${'categoryDropdown'}`)" :selected="categoryIds"
                        @input="categoryIds = $event" />
                    </div>

                    <div v-if="responseId === 'yes' && methodId === 'phone'">
                      <div class="form__field date-time-wrapper">
                        <div class="date-picker">
                          <Datepicker class="input input--default date-picker" :class="{ 'input--error': dateHasError }"
                            :config="statics.datePickerConfig" :placeholder="$t(`addCallModal.${'date'}`)
                              " v-model="date" />
                          <div class="form__error" v-if="dateHasError">
                            {{ $t(`addLeadModal.${'dateErrorMsg'}`) }}
                          </div>
                        </div>
                        <div class="date-picker">

                          <VueTimepicker close-on-complete hide-clear-button
                            class="input input--default input time-picker" :class="{ 'input--error': timeHasError }"
                            v-model="time" placeholder="--  :  --" />
                          <div class="form__error" v-if="timeHasError">
                            {{ $t(`addLeadModal.${'timeErrorMsg'}`) }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form__field">
                      <VSelect :options="statuses" :reduce="(status) => status.id"
                        :placeholder="$t('addPrivateCostumerModal.statusPlaceholder')" label="name" v-model="statusId"
                        class="select select--default" :class="{ 'select--error': statusHasError }" />
                      <div class="form__error" v-if="statusHasError">
                        {{ $t(`addPrivateCostumerModal.${"subStatusErrorMsg"}`) }}
                      </div>
                    </div>

                    <div class="form__field ">
                      <Datepicker class="input input--default" :class="{ 'select--error': deadlineHasError }"
                        :config="statics.datePickerConfig" :placeholder="$t(`addLeadModal.${'deadline'}`)"
                        v-model="deadline" />
                      <div class="form__error" v-if="deadlineHasError">
                        {{ $t(`addLeadModal.${'deadlineErrorMsg'}`) }}
                      </div>
                    </div>
                  </div>

                  <div class="termination__column termination__column--middle">
                    <div class="form__field">
                      <div v-if="agents && agents.length">
                        <VSelect class="select select--default" :options="agents"
                          :class="{ 'select--error': agentHasError }" :reduce="(agent) => agent.id"
                          :getOptionLabel="(agent) => `${agent.first_name} ${agent.last_name}`"
                          :placeholder="$t(`addLeadModal.${'agentDropdown'}`)" v-model="agentId" />
                        <div class="form__error" v-if="agentHasError">
                          {{ $t(`addLeadModal.${"agentErrorMsg"}`) }}
                        </div>
                      </div>

                      <div v-else>
                        <div class="input input--default input--readonly">
                          {{ loggedUser.first_name }} {{ loggedUser.last_name }}
                        </div>
                      </div>
                    </div>

                    <div class="form__field dobule-form-fields">
                      <div :class="[(methodId && methodId !== 'termin') ? 'small-form-field' : 'big-form-field']">
                        <VSelect class="select select--default" :options="methods" :reduce="(method) => method.value"
                          :getOptionLabel="(method) => method.label"
                          :placeholder="$t(`addLeadModal.${'methodDropdown'}`)" v-model="methodId" />
                      </div>

                      <div v-if="methodId && methodId !== 'termin'" class="small-form-field">
                        <VSelect class="select select--default" :options="responses"
                          :reduce="(response) => response.value" :getOptionLabel="(response) => response.label"
                          :placeholder="$t(`addLeadModal.${'responseDropdown'}`)" v-model="responseId" />
                      </div>
                    </div>

                    <div v-if="responseId === 'yes' && methodId === 'phone'">
                      <div class="form__field form__field__call__duration">
                        <div class="call__duration__label">
                          <p><i>{{ $t(`addCallModal.${'callDuration'}`) }}</i></p>
                        </div>
                        <div style="display: flex; align-items: center; gap: 9px;">
                          <div class="call__duration__types">
                            <p class="call__duration__value"
                              :class="{ 'call__duration__value--active': durationMinutes == 15 }"
                              @click="selectCallDuration(15)">
                              15 min
                            </p>
                            <p class="call__duration__value"
                              :class="{ 'call__duration__value--active': durationMinutes == 30 }"
                              @click="selectCallDuration(30)">
                              30 min
                            </p>
                            <p class="call__duration__value"
                              :class="{ 'call__duration__value--active': durationMinutes == 45 }"
                              @click="selectCallDuration(45)">
                              45 min
                            </p>
                          </div>
                          <div style="width: 80px;">
                            <div class="custom-duration-wrapper" :class="{ 'input--error': durationHasError }">
                              <input type="number" v-model="hours" min="0" max="59" @input="validateHours"
                                class=" custom-duration" placeholder="HH" />
                              <p><b>:</b></p>
                              <input type="number" v-model="minutes" min="0" max="59" @input="validateMinutes"
                                class=" custom-duration" placeholder="mm" />
                            </div>
                          </div>
                        </div>
                        <div class="form__error" v-if="durationHasError">
                          {{ $t(`addLeadModal.${'durationErrorMsg'}`) }}
                        </div>
                      </div>
                    </div>

                    <div class="form__field ">
                      <VSelect class="select select--default" :options="referals"
                        :class="{ 'select--error': referalHasError }" :reduce="(referal) => referal.id"
                        :getOptionLabel="(referal) => referal.name"
                        :placeholder="$t(`addLeadModal.${'referalDropdown'}`)" v-model="referalId" />
                      <div class="form__error" v-if="referalHasError">
                        {{ $t(`addLeadModal.${"referalErrorMsg"}`) }}
                      </div>
                    </div>

                    <div class="form__field ">
                      <input type="text" :placeholder="$t(`addLeadModal.${'referalNote'}`)"
                        class="input input--default " v-model="referalNote">
                    </div>
                  </div>

                  <div class="termination__column">
                    <DropFile @input="files = $event" />
                  </div>
                </div>
                <div class="termination__row termination__textarea__row">
                  <div class="form__field form__notes__textarea">
                    <textarea :placeholder="$t(`addLeadModal.${'text'}`)" cols="30" rows="10"
                      class="input input--default termination__textarea" v-model="comment"
                      style="max-width: initial !important;">
                    </textarea>
                  </div>
                </div>


                <div class="url-links" v-if="deadline">
                  <h3 class="url-links__title">{{ $t(`calendar.${"title"}`) }}</h3>
                  <p class="url-links__subtitle">{{ $t(`calendar.${"subtitle"}`) }}</p>

                  <div class="calendar-link" v-if="deadline">
                    <div class="calendar-link__icon calendar-link__icon--google"></div>
                    <div class="calendar-link__content">
                      <div class="calendar-link__name">Google Calendar</div>
                    </div>
                    <button class="calendar-link__btn" @click="copyToClipboard(generateCalendarLinks().google)">

                      Copy
                    </button>
                  </div>

                  <div class="calendar-link" v-if="deadline">
                    <div class="calendar-link__icon calendar-link__icon--outlook"></div>
                    <div class="calendar-link__content">
                      <div class="calendar-link__name">Outlook</div>
                    </div>
                    <button class="calendar-link__btn" @click="copyToClipboard(generateCalendarLinks().outlook)">

                      Copy
                    </button>
                  </div>

                  <div class="calendar-link" v-if="deadline">
                    <div class="calendar-link__icon calendar-link__icon--office365"></div>
                    <div class="calendar-link__content">
                      <div class="calendar-link__name">Office 365</div>
                    </div>
                    <button class="calendar-link__btn" @click="copyToClipboard(generateCalendarLinks().office365)">

                      Copy
                    </button>
                  </div>

                  <div class="calendar-link" v-if="deadline">
                    <div class="calendar-link__icon calendar-link__icon--yahoo"></div>
                    <div class="calendar-link__content">
                      <div class="calendar-link__name">Yahoo Calendar</div>
                    </div>
                    <button class="calendar-link__btn" @click="copyToClipboard(generateCalendarLinks().yahoo)">

                      Copy
                    </button>
                  </div>

                  <div class="calendar-link  ">
                    <div class="calendar-link__icon calendar-link__icon--download"></div>
                    <div class="calendar-link__content">
                      <div class="calendar-link__name">Download ICS File</div>
                      <div class="calendar-link__description">Compatible with all calendar apps</div>
                    </div>
                    <button class="calendar-link__btn" @click="downloadICSFile">

                      Download
                    </button>
                  </div>

                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
      <div v-if="isRequesting" class="modal__button modal__button--submit button button--default button--loading"></div>

      <div v-else>
        <button class="modal__button modal__button--submit button button--default" @click="addLead()">
          <span>{{ $t(`addLeadModal.${'saveBtn'}`) }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import DropFile from "@/components/DropFile";
import Loading from "@/partials/Loading";
import MultiSelectDropdown from "@/partials/MultiSelectDropdown";
import { mapGetters } from "vuex";
import statics from "@/statics";

export default {
  name: "AddLeadModal",

  components: {
    DropFile,
    Loading,
    MultiSelectDropdown,
  },

  data() {
    return {
      formLoading: true,
      isRequesting: false,
      statics,

      agentId: "",
      categoryIds: [],
      referalId: "",
      referalNote: "",
      methodId: "",
      responseId: "",
      statusId: "",
      deadline: "",
      comment: "",
      files: [],

      agentHasError: false,
      referalHasError: false,
      statusHasError: false,

      durationMinutes: null,
      durationMinutesCustom: null,
      hours: "",
      minutes: "",
      date: "",
      time: "00:00",
      formattedTime: '',
      placeholder: 'Time',
      callId: null,

      dateHasError: false,
      timeHasError: false,
      durationHasError: false,
      deadlineHasError: false,
    };
  },

  computed: {
    ...mapGetters([
      "customerDetails",
      "leadCustomerForms",
      "loggedUser",
      "leadToEdit",
      "leadsPerPage",
    ]),

    isEditMode() {
      return !!this.leadToEdit;
    },

    latestLead() {
      if (this.customerDetails?.latest_lead) {
        return this.customerDetails.latest_lead;
      }
      if (this.leadsPerPage?.data && this.leadsPerPage.data.length > 0) {
        return this.leadsPerPage.data[0];
      }
      return null;
    },

    agents() {
      return this.leadCustomerForms.agents || [];
    },

    categories() {
      return this.leadCustomerForms.branchCategories || [];
    },

    referals() {
      return this.leadCustomerForms.referrals || [];
    },

    methods() {
      return this.leadCustomerForms.contactMethods || [];
    },

    responses() {
      return this.leadCustomerForms.response || [];
    },

    statuses() {
      return this.leadCustomerForms.statuses;
    },

    customerId() {
      return this.$store.getters.customerDetailsId;
    }
  },

  async created() {
    this.formLoading = true;

    if (!(this.$checkRolePermission('customer_create') && this.$checkRolePermission('customer_edit'))) {
      this.closeModal();
    } else {
      this.populateFormForEdit();

      if (this.customerDetails && this.customerDetails.team) {
        this.teamId = Number(this.customerDetails.team.id);
        await this.$store.dispatch("getLeadCustomerForms", this.teamId);
      }

      this.setDefaultAgentIfNeeded();

      if (!this.isEditMode && this.latestLead) {
        this.populateFromLatestLead();
      }
    }

    this.formLoading = false;
  },

  watch: {
    minutes: "updateCallDuration",
    hours: "updateCallDuration",

    time(value) {
      if (value && value != "00:00") {
        this.timeHasError = false;
      } else {
        this.timeHasError = true;
      }
    },

    date(value) {
      if (value) {
        this.dateHasError = false;
      } else {
        this.dateHasError = true;
      }
    },

    deadline(value) {
      if (value) {
        this.deadlineHasError = false;
      } else if (this.methodId === 'termin') {
        this.deadlineHasError = true;
      }
    },

    durationMinutesCustom(value) {
      if (value) {
        this.durationHasError = false;
      } else {
        this.durationHasError = true;
      }
    },

    durationMinutes(value) {
      if (value) {
        this.durationHasError = false;
      } else {
        this.durationHasError = true;
      }
    },

    agentId(value) {
      this.agentHasError = !value;
    },

    referalId(value) {
      this.referalHasError = !value;
    },

    statusId(value) {
      this.statusHasError = !value;
    },

    responseId(newValue) {
      if (newValue === 'yes' && !this.isEditMode) {
        if (!this.date || !this.time || this.time === '00:00') {
          this.setCurrentDateTime();
        }
      }
    },

    methodId(value) {
      if (value === 'termin') {
        this.deadlineHasError = !this.deadline;
      } else {
        this.deadlineHasError = false;
      }
    },

    customerDetails: async function (newVal) {
      if (!newVal || !newVal.team) return;
      if (this.leadCustomerForms && Object.keys(this.leadCustomerForms).length > 0) return;
      this.formLoading = true;
      this.teamId = Number(newVal.team.id);
      await this.$store.dispatch("getLeadCustomerForms", this.teamId);

      this.setDefaultAgentIfNeeded();

      if (!this.isEditMode && this.latestLead) {
        this.populateFromLatestLead();
      }

      this.formLoading = false;
    },

    loggedUser(newVal) {
      if (!newVal) return;
      this.setDefaultAgentIfNeeded();
    },

    leadToEdit: {
      async handler(newVal) {
        if (newVal) {
          this.populateFormForEdit();

          if (this.customerDetails?.team && (!this.leadCustomerForms || Object.keys(this.leadCustomerForms).length === 0)) {
            this.formLoading = true;
            this.teamId = Number(this.customerDetails.team.id);
            await this.$store.dispatch("getLeadCustomerForms", this.teamId);
            this.formLoading = false;
          }
        }
      },
      immediate: true,
    },
  },

  destroyed() {
    this.closeModal();
  },

  methods: {
    validateMinutes() {
      if (this.durationMinutes) {
        this.durationMinutes = null;
      }
      if (this.minutes > 59) {
        this.minutes = 59;
      } else if (this.minutes < 0 || isNaN(this.minutes)) {
        this.minutes = "";
      }
    },

    validateHours() {
      if (this.durationMinutes) {
        this.durationMinutes = null;
      }
      if (this.hours < 0 || isNaN(this.hours)) {
        this.hours = "";
      }
    },

    updateCallDuration() {
      var timeString = 0;
      if (Number(this.hours) && Number(this.hours) > 0) {
        timeString = Number(this.hours) * 60;
      }
      if (this.minutes && Number(this.minutes) > 0) {
        timeString += Number(this.minutes);
      }
      this.durationMinutesCustom = timeString;
    },

    selectCallDuration(callDuration) {
      this.hours = "";
      this.minutes = "";
      this.durationMinutesCustom = null;
      this.durationMinutes = callDuration;
    },


    closeModal() {
      this.$store.commit("setShowAddLeadModal", false);
      this.$store.commit("setLeadToEdit", null);

      if (this.$route.name === 'Leads') {
        this.$store.commit("setCustomerDetails", null);
        this.$store.commit("setCustomerDetailsId", null);
      }
    },

    populateFormForEdit() {
      if (!this.leadToEdit) return;

      const lead = this.leadToEdit;

      if (lead.customer && !this.customerDetails) {
        this.$store.commit("setCustomerDetails", lead.customer);
        this.$store.commit("setCustomerDetailsId", lead.customer.id);
      }

      this.agentId = lead.agent?.id || "";
      this.categoryIds = lead.branch_categories?.map(cat => cat.id) || [];
      this.referalId = lead.referral?.id || "";
      this.referalNote = lead.referral_note || "";
      this.methodId = lead.contact_method || "";
      this.responseId = lead.response || "";
      this.statusId = lead.status?.id || "";
      this.deadline = lead.deadline || "";
      this.comment = lead.comment || "";

      if (lead.calls && lead.calls.length > 0) {
        this.callId = lead.calls[0].id;
        this.date = lead.calls[0].date;
        // Ensure time is in proper format (HH:mm) for VueTimepicker
        const callTime = lead.calls[0].time;
        if (callTime) {
          // Remove seconds if present (e.g., "14:30:00" -> "14:30")
          this.time = callTime.substring(0, 5);
        }
        
        const duration = lead.calls[0].duration_minutes;
        if (duration === 15 || duration === 30 || duration === 45) {
          this.durationMinutes = duration;
        } else if (duration) {
          this.hours = Math.floor(duration / 60);
          this.minutes = duration % 60;
          this.durationMinutesCustom = duration;
        }
      }

      if (lead.customer?.team?.id) {
        this.teamId = Number(lead.customer.team.id);
      }
    },

    populateFromLatestLead() {
      if (!this.latestLead) return;

      if (this.latestLead.branch_categories && this.latestLead.branch_categories.length > 0) {
        this.categoryIds = this.latestLead.branch_categories.map(cat => cat.id);
      }

      if (this.latestLead.referral?.id) {
        this.referalId = this.latestLead.referral.id;
      }

      if (this.latestLead.agent?.id) {
        this.agentId = this.latestLead.agent.id;
      }

      if (this.latestLead.status?.id) {
        this.statusId = this.latestLead.status.id;
      }

      if (this.latestLead.referral_note) {
        this.referalNote = this.latestLead.referral_note;
      }
    },

    setCurrentDateTime() {
      const now = new Date();

      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      this.date = `${year}-${month}-${day}`;

      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      this.time = `${hours}:${minutes}`;
    },

    validateFields(callback) {
      this.agentHasError = !this.agentId;
      this.referalHasError = !this.referalId;
      this.statusHasError = !this.statusId;

      if (this.methodId === 'termin') {
        this.deadlineHasError = !this.deadline;
        this.dateHasError = false;
        this.timeHasError = false;
        this.durationHasError = false;
      } else if (this.responseId === 'yes' && this.methodId === 'phone') {
        this.dateHasError = !this.date;
        this.timeHasError = !this.time || this.time === "00:00";
        const totalDuration = this.durationMinutes || this.durationMinutesCustom;
        this.durationHasError = !totalDuration || totalDuration === 0;
        this.deadlineHasError = false;
      } else {
        this.dateHasError = false;
        this.timeHasError = false;
        this.durationHasError = false;
        this.deadlineHasError = false;
      }

      const isValid = !this.agentHasError && !this.referalHasError && !this.statusHasError &&
        !this.dateHasError && !this.timeHasError && !this.durationHasError && !this.deadlineHasError;

      callback(isValid);
    },

    formatTime(event) {
      const input = event.target.value.replace(/[^0-9]/g, '');
      let formatted = '';
      if (input.length >= 3) {
        formatted = `${input.slice(0, 2)}:${input.slice(2, 4)}`;
      } else if (input.length >= 1) {
        formatted = input;
      }
      this.formattedTime = formatted;
      this.time = formatted;
    },

    formatTimeBeforeSend(time) {
      // Handle both string and object formats from VueTimepicker
      if (typeof time === 'object' && time !== null) {
        // VueTimepicker returns an object like { HH: "14", mm: "30" }
        const hours = time.HH || time.hh || '00';
        const minutes = time.mm || '00';
        return `${hours}:${minutes}`;
      }
      
      // Handle string format
      if (typeof time === 'string') {
        let [hours, minutes] = time.split(':');
        return `${hours}:${minutes}`;
      }
      
      return '00:00';
    },

    async addLead() {
      this.isRequesting = true;

      if (!this.customerDetails || !this.customerDetails.id) {
        this.$store.commit("setToast", {
          display: true,
          type: "error",
          message: this.$t('addLeadModal.noCustomerSelectedError'),
        });
        this.isRequesting = false;
        return;
      }

      this.validateFields(async (isValid) => {
        if (isValid) {
          try {
            const leadData = {
              team_id: this.teamId,
              agent_id: this.agentId,
              customer_id: this.customerDetails.id,
              branch_category_ids: this.categoryIds,
              referral_id: this.referalId,
              status_id: this.statusId,
              contact_method: this.methodId,
              response: this.responseId,
              deadline: this.deadline,
              comment: this.comment,
              referral_note: this.referalNote,
            };

            if (this.responseId === 'yes' && this.methodId === 'phone') {
              leadData.call_date = this.date;
              leadData.call_time = this.formatTimeBeforeSend(this.time);
              leadData.call_duration_minutes = this.durationMinutes || this.durationMinutesCustom || 0;
               
              if (this.isEditMode && this.callId) {
                leadData.call_id = this.callId;
              }  
            }
 

            const statusNum = Number(this.statusId);
            const willRedirect = statusNum === 4 && this.customerDetails && this.customerDetails.id;
            const customerId = this.customerDetails.id; 

            if (this.isEditMode) {
              await this.$store.dispatch('updateLead', {
                leadId: this.leadToEdit.id,
                leadData
              });
            } else {
              const files = this.files.map((file) => file.file);
              await this.$store.dispatch('createLead', { leadData, files });

              if (this.$route.name === 'Leads' && !willRedirect) {
                await this.$store.dispatch('fetchLeadCustomers');
              }
            }

            this.closeModal();

            if (willRedirect) {
              await this.$store.dispatch('getGlobalCustomer', customerId);
              await this.$router.replace({
                path: `/account-details/customer/${customerId}`,
                query: { tab: 5 }
              });
              this.$store.commit('setShowAddCustomerServicesModal', true)
            }
          } catch (error) {
            // Error toast is now handled by the store action
          } finally {
            this.isRequesting = false;
          }
        } else {
          this.$store.commit("setToast", {
            display: true,
            type: "error",
            message: this.$t('addLeadModal.validationError'),
          });
          this.isRequesting = false;
        }
      });
    },

    setDefaultAgentIfNeeded() {
      if (this.agentId) return;

      if ((!this.agents || this.agents.length === 0) && this.loggedUser && this.loggedUser.id) {
        this.agentId = this.loggedUser.id;
      }
    },

    async copyToClipboard(url) {
      try {
        await navigator.clipboard.writeText(url);
        window.open(url, '_blank');
        this.$store.commit("setToast", {
          display: true,
          type: "success",
          message: this.$t('calendar.copySuccess') || 'Link copied to clipboard!',
        });
      } catch (error) {
        this.$store.commit("setToast", {
          display: true,
          type: "error",
          message: this.$t('calendar.copyError') || 'Failed to copy link',
        });
      }
    },

    generateCalendarLinks() { 
      if (!this.deadline) {
        return null;
      }
 
      const [year, month, day] = this.deadline.split('-');
      const startDate = new Date(year, month - 1, day, 12, 0); 
      const eventDuration = 60;  
 
      if (!startDate || isNaN(startDate.getTime())) {
        return null;
      }
 
      const endDate = new Date(startDate);
      endDate.setMinutes(endDate.getMinutes() + eventDuration);
 
      const customerName = this.customerDetails?.first_name
        ? `${this.customerDetails.first_name} ${this.customerDetails.last_name}`
        : this.customerDetails?.company_name || 'Customer';

      const eventTitle = encodeURIComponent(`Follow-up - ${customerName}`);
 
      let descriptionParts = [];
 
      descriptionParts.push(`Customer: ${customerName}`);
 
      if (this.categoryIds && this.categoryIds.length > 0) {
        const selectedCategories = this.categories
          .filter(cat => this.categoryIds.includes(cat.id))
          .map(cat => cat.name)
          .join(', ');
        if (selectedCategories) {
          descriptionParts.push(`Categories: ${selectedCategories}`);
        }
      }
 
      if (this.statusId) {
        const selectedStatus = this.statuses?.find(s => s.id === this.statusId);
        if (selectedStatus) {
          descriptionParts.push(`Status: ${selectedStatus.name}`);
        }
      }
 
      if (this.agentId) {
        const selectedAgent = this.agents?.find(a => a.id === this.agentId) || this.loggedUser;
        if (selectedAgent) {
          descriptionParts.push(`Agent: ${selectedAgent.first_name} ${selectedAgent.last_name}`);
        }
      }
 
      if (this.methodId) {
        const selectedMethod = this.methods?.find(m => m.value === this.methodId);
        if (selectedMethod) {
          descriptionParts.push(`Method: ${selectedMethod.label}`);
        }
      }
 
      if (this.responseId) {
        const selectedResponse = this.responses?.find(r => r.value === this.responseId);
        if (selectedResponse) {
          descriptionParts.push(`Response: ${selectedResponse.label}`);
        }
      }
 
      if (this.referalId) {
        const selectedReferal = this.referals?.find(r => r.id === this.referalId);
        if (selectedReferal) {
          descriptionParts.push(`Referral: ${selectedReferal.name}`);
        }
      }
 
      if (this.referalNote) {
        descriptionParts.push(`Referral Note: ${this.referalNote}`);
      }
 
      if (this.comment) {
        descriptionParts.push(`Notes: ${this.comment}`);
      }

      const eventDescription = encodeURIComponent(descriptionParts.join('\n'));
 
      const formatDateTime = (date) => {
        return date.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
      };

      const startDateTime = formatDateTime(startDate);
      const endDateTime = formatDateTime(endDate);

      return {
        google: `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${eventTitle}&dates=${startDateTime}/${endDateTime}&details=${eventDescription}`,
        outlook: `https://outlook.live.com/owa/?path=/calendar/action/compose&rru=addevent&subject=${eventTitle}&startdt=${startDateTime}&enddt=${endDateTime}&body=${eventDescription}`,
        office365: `https://outlook.office.com/calendar/0/deeplink/compose?path=/calendar/action/compose&rru=addevent&subject=${eventTitle}&startdt=${startDateTime}&enddt=${endDateTime}&body=${eventDescription}`,
        yahoo: `https://calendar.yahoo.com/?v=60&view=d&type=20&title=${eventTitle}&st=${startDateTime}&et=${endDateTime}&desc=${eventDescription}`
      };
    },

    downloadICSFile() { 
      if (!this.deadline) {
        this.$store.commit("setToast", {
          display: true,
          type: "warning",
          message: this.$t('calendar.noEventData') || 'Unable to generate calendar event',
        });
        return;
      }
 
      const [year, month, day] = this.deadline.split('-');
      const startDate = new Date(year, month - 1, day, 12, 0);  
      const eventDuration = 60;  
      const dateString = this.deadline;
 
      if (!startDate || isNaN(startDate.getTime())) {
        this.$store.commit("setToast", {
          display: true,
          type: "warning",
          message: this.$t('calendar.noEventData') || 'Unable to generate calendar event',
        });
        return;
      }
 
      const endDate = new Date(startDate);
      endDate.setMinutes(endDate.getMinutes() + eventDuration);

      const formatICSDate = (date) => {
        return date.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
      };
 
      const customerName = this.customerDetails?.first_name
        ? `${this.customerDetails.first_name} ${this.customerDetails.last_name}`
        : this.customerDetails?.company_name || 'Customer';
 
      let descriptionParts = [];
 
      descriptionParts.push(`Customer: ${customerName}`);
 
      if (this.categoryIds && this.categoryIds.length > 0) {
        const selectedCategories = this.categories
          .filter(cat => this.categoryIds.includes(cat.id))
          .map(cat => cat.name)
          .join(', ');
        if (selectedCategories) {
          descriptionParts.push(`Categories: ${selectedCategories}`);
        }
      }
 
      if (this.statusId) {
        const selectedStatus = this.statuses?.find(s => s.id === this.statusId);
        if (selectedStatus) {
          descriptionParts.push(`Status: ${selectedStatus.name}`);
        }
      }
 
      if (this.agentId) {
        const selectedAgent = this.agents?.find(a => a.id === this.agentId) || this.loggedUser;
        if (selectedAgent) {
          descriptionParts.push(`Agent: ${selectedAgent.first_name} ${selectedAgent.last_name}`);
        }
      }
 
      if (this.methodId) {
        const selectedMethod = this.methods?.find(m => m.value === this.methodId);
        if (selectedMethod) {
          descriptionParts.push(`Method: ${selectedMethod.label}`);
        }
      }
 
      if (this.responseId) {
        const selectedResponse = this.responses?.find(r => r.value === this.responseId);
        if (selectedResponse) {
          descriptionParts.push(`Response: ${selectedResponse.label}`);
        }
      }
 
      if (this.referalId) {
        const selectedReferal = this.referals?.find(r => r.id === this.referalId);
        if (selectedReferal) {
          descriptionParts.push(`Referral: ${selectedReferal.name}`);
        }
      }
 
      if (this.referalNote) {
        descriptionParts.push(`Referral Note: ${this.referalNote}`);
      }
 
      if (this.comment) {
        descriptionParts.push(`Notes: ${this.comment}`);
      }

      const description = descriptionParts.join('\\n').replace(/\n/g, '\\n');

      const icsContent = `BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//Lead Management//Follow-up//EN
BEGIN:VEVENT
UID:${Date.now()}@leadsystem.com
DTSTAMP:${formatICSDate(new Date())}
DTSTART:${formatICSDate(startDate)}
DTEND:${formatICSDate(endDate)}
SUMMARY:Follow-up - ${customerName}
DESCRIPTION:${description}
STATUS:CONFIRMED
END:VEVENT
END:VCALENDAR`;

      const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `follow-up-${dateString}.ics`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);

      this.$store.commit("setToast", {
        display: true,
        type: "success",
        message: this.$t('calendar.downloadSuccess') || 'ICS file downloaded!',
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "../assets/scss/_termination-potential-policy.scss";

.dobule-form-fields {
  display: flex;
  justify-content: space-between;
}

.big-form-field {
  width: 100% !important;
}

.small-form-field {
  width: 49% !important;
}

.termination__row {
  border: 0;
}

// .termination__textarea__row {
//   margin-top: -40px !important;
// }

.custom-duration-wrapper {

  background-color: var(--bg-3);

  color: var(--text-3);
  padding: 0 10px;
  font-size: var(--x-small);
  border-radius: var(--radius-1);
  font-family: var(--muli-text-semi-bold);
  border: 1px solid transparent;


  display: flex;
  align-items: center;
  padding: 0;

}

.custom-duration {
  background-color: transparent;
  //  border: 1px solid ;
  height: 40px;
  color: var(--text-3);

  font-size: var(--x-small);
  text-align: center;
  font-family: var(--muli-text-semi-bold);
}


::v-deep .vue__time-picker input.display-time {
  width: 100%;
  padding: .3em .5em;
  font-size: 1em;
  height: 100%;
  background-color: transparent;
  border: none;
  text-align: center;
  color: var(--text-2);
  font-family: var(--muli-text-semi-bold);
}

.form__field__call__duration {
  margin-top: -8px;
}

.call__duration__label {
  margin-bottom: -6px;
}

[data-theme="dark"] .call__duration__label {
  p {
    color: white;
  }
}


.call__duration__label p {
  color: #7F8FA480;
  font-size: 14px;
}


.call__duration__types {
  display: flex;
  gap: 12px;
}


.call__duration__value {
  color: #B9C2CD;
  font-size: 16px;
  cursor: pointer;
}


.call__duration__value--active {
  color: #22DB8E;
}



.custom-time-input {
  position: relative;
  width: 48%;
}

.custom-input {
  appearance: none;
  color: var(--text-2);
  background-color: var(--bg-3);
  border-radius: 10px;
  padding: 0 10px;
  height: 40px;
  font-size: 16px;
  width: 100%;
  box-sizing: border-box;
}

.custom-input::placeholder {
  font-family: var(--muli-text-semi-bold);
  color: var(--text-8);
}


.date-picker {
  width: 48%;
  position: relative;
  z-index: 1;
}

.date-time-wrapper {
  display: flex;
  justify-content: space-between;
}


.form__notes__textarea {
  width: 66%;
}

// Calendar Links Styling
.url-links {
  margin-top: 20px;
  width: 100%;
}

.url-links__title {
  font-size: 20px;
  font-weight: 600;
  color: var(--text-9);
  margin: 0 0 8px 0;
  font-family: var(--muli-text-bold);
}

.url-links__subtitle {
  font-size: 14px;
  color: var(--text-9);
  margin: 0 0 20px 0;
  font-family: var(--muli-text-regular);
}

.calendar-link {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background-color: var(--bg-3);
  border-radius: 10px;
  margin-bottom: 12px;
  transition: all 0.2s ease;
  width: 32%;

  &:not(:nth-of-type(3n)) {
    margin-right: 2%;
  }

  &:last-child {
    width: 66%;
    margin: 0;
  }

  &:hover {
    border-color: var(--border-2);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }

  &--download {
    margin-bottom: 16px;
  }
}

.calendar-link__icon {
  width: 24px;
  height: 24px;
  border-radius: 8px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;

  &--google {
    &::before {
      content: '📅';
    }
  }

  &--outlook {
    &::before {
      content: '📧';
    }
  }

  &--office365 {
    &::before {
      content: '📊';
    }
  }

  &--yahoo {
    &::before {
      content: '📆';
    }
  }

  &--download {
    &::before {
      content: '📥';
    }
  }
}

.calendar-link__content {
  flex: 1;
  min-width: 0;
}

.calendar-link__name {
  font-size: 15px;
  font-weight: 600;
  color: var(--text-9);
  margin-bottom: 4px;
  font-family: var(--muli-text-semi-bold);
}

.calendar-link__url {
  font-size: 13px;
  color: var(--text-9);
  font-family: var(--muli-text-semi-bold);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.calendar-link__description {
  font-size: 13px;
  color: var(--text-9);
  font-family: var(--muli-text-regular);
}

.calendar-link__btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background-color: transparent;
  border-radius: 6px;
  color: var(--text-9);
  font-size: 14px;
  font-family: var(--muli-text-semi-bold);
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
  background-color: var(--bg-1);

  &:hover {
    background-color: var(--bg-3);
    border-color: var(--border-2);
  }

  &:active {
    transform: scale(0.98);
  }
}
</style>
